// extracted by mini-css-extract-plugin
module.exports = {"expireContainer":"creditsExpireDashboard_expireContainer__kXtDX","heading":"creditsExpireDashboard_heading__jbUkj","postJob":"creditsExpireDashboard_postJob__yoBti"};